import "jquery-ui/ui/widgets/tooltip";
import inputTextTemplate from "./input/input-text.html";

ko.components.register('input-text', {
    viewModel: function (params) {
        this.label = ko.unwrap(params.label);
        this.value = ko.observable(ko.unwrap(params.value));
        this.isFocused = ko.observable(false);
        this.attr = ko.computed(() => {
            const data = {
                type: params.type,
                name: params.name,
                placeholder: params.placeholder,
                required: !!params.required,
                pattern: params.pattern || null,
            };

            if (params.pattern) {
                data.pattern = params.pattern;
            }
            if (params.maxLength) {
                data['maxlength'] = params.maxLength;
            }
            if (params.minLength) {
                data['minlength'] = params.minLength;
            }
            if (params.max) {
                data.max = params.max;
            }
            if (params.min) {
                data.min = params.min;
            }

            return data;
        });
        this.events = {
            focus: () => this.isFocused(true),
            blur: () => this.isFocused(false),
        };
    },
    template: inputTextTemplate,
});

